<!--
 * @Author: RYL
 * @Description: 新增采集模板
 * @Date: 2020-10-16 14:20:14
 * @LastEditTime: 2022-03-10 14:52:36
-->
<template>
  <div v-if="dialogVisible">
    <el-dialog
      :title="
        type === 'edit'
          ? $t('lang.devicesManagement.editATemplate')
          : $t('lang.devicesManagement.addATemplate')
      "
      :visible.sync="dialogVisible"
      @close="hide"
      width="70%"
      center
    >
      <div>
        <el-divider content-position="left">{{
          $t("lang.collect.TemplateInformation")
        }}</el-divider>
        <el-form
          :model="collectForm"
          ref="collectForm"
          inline
          :rules="rules"
          label-width="140px"
          label-position="right"
        >
          <el-form-item :label="$t('lang.collect.templateName')" prop="name">
            <el-input
              class="form-input"
              size="mini"
              v-model="collectForm.name"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('lang.collect.TemplateType')" prop="type">
            <!-- <el-input class="form-input" size="mini" v-model="" clearable></el-input> -->
            <el-select
              size="mini"
              :disabled="issave || type == 'edit'"
              :value="typeListObj[collectForm.type]"
              @change="typeChange"
            >
              <el-option
                v-for="item in typeListOptions"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('lang.collect.describe')" prop="description">
            <el-input
              type="textarea"
              :rows="2"
              v-model="collectForm.description"
              size="mini"
              class="form-input"
              clearable
            ></el-input>
          </el-form-item>
        </el-form>
        <div style="text-align: center">
          <el-button
            size="mini"
            type="success"
            @click="submitForm('submitForm')"
            >{{ $t("lang.collect.save") }}</el-button
          >
        </div>
      </div>
      <div style="width: 100%" v-if="Permission.indexOf(246) !== -1">
        <el-divider content-position="left">{{
          $t("lang.collect.variableInformation")
        }}</el-divider>
        <p
          style="color:red"
          v-if="type !== 'edit' && Permission.indexOf(247) !== -1"
        >
          {{ $t("lang.collect.PleaseSave") }}
        </p>
        <add-params
          :templateType="collectForm.type.toString()"
          Height="400"
          ref="addParams"
          :templateId="templateId"
          @setParamsIds="setParamsIds"
        ></add-params>
      </div>
      <div slot="footer">
        <el-button size="mini" @click="hide">{{
          $t("lang.collect.Cancel")
        }}</el-button>
        <el-button
          type="primary"
          v-if="Permission.indexOf(246) !== -1"
          :disabled="templateId ? false : true"
          size="mini"
          @click="monitor"
          >{{ $t("lang.collect.IssueCollection") }}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import addParams from "../../../components/addParams";
import { addTemplate, editTemplate } from "@/api/cloudMonitor/templateList";
import { monitorParams } from "@/api/cloudMonitor/paramsList";
import { cloneDeep, isEqual } from "lodash";
import { getPermission } from "@/cookie/cookie";
import { typeListOptions, typeListObj } from "@/utils/paramsConfig";
export default {
  components: {
    addParams,
  },
  data() {
    return {
      type: "",
      dialogVisible: false,
      issave: false,
      collectForm: {
        name: "",
        type: "0",
        admodel: 1,
        description: "",
      },
      paramsIds: [], // 缓存变动的变量Id
      copyData: {},
      templateId: "", // 添加后的模板Id
      rules: {
        name: [
          {
            required: true,
            message: this.$t("lang.FastAccess.pleaseTname"),
            trigger: ["blur"],
          },
        ],
        admodel: [
          {
            required: true,
            message: this.$t("lang.FastAccess.selectedCollection"),
            trigger: ["blur", "change"],
          },
        ],
      },
      Permission: [],
      typeListOptions,
      typeListObj,
    };
  },
  methods: {
    clearData() {
      this.collectForm = {
        name: "",
        type: "0",
        admodel: 1,
        description: "",
      };
      this.templateId = "";
    },
    show(item) {
      this.clearData();
      this.Permission = getPermission();
      if (item && item.id) {
        this.type = "edit";
        this.collectForm = item;
        this.templateId = item.id;
        this.copyData = cloneDeep(this.collectForm);
      } else {
        this.type = "add";
      }
      this.dialogVisible = true;
    },
    // 点击取消,取消前要先下发未下发的变量采集
    hide() {
      if (this.paramsIds.length > 0) {
        this.$message.warning(this.$t("lang.FastAccess.warning1"));
        this.dialogVisible = true;
        this.issave = false;
      } else {
        this.dialogVisible = false;
        this.issave = false;
      }
    },
    // 设置缓存的变量Id
    setParamsIds(val) {
      console.log(val);
      this.paramsIds.push(val);
      this.paramsIds = Array.from(new Set(this.paramsIds));
      console.log(this.paramsIds);
    },
    // 下发指令
    monitor() {
      // if(this.paramsIds.length > 0) {
      let monitorData = {
        mid: this.templateId,
        vids: this.paramsIds,
        action: 0,
        type: this.collectForm.type,
      };
      monitorParams(monitorData)
        .then((res) => {
          if (res.data.code === 0) {
            this.$message.success(this.$t("lang.collect.msg5"));
            this.paramsIds = [];
            this.dialogVisible = false;
          } else {
            this.$message.error(this.$t("lang.collect.msg6"));
          }
        })
        .catch(() => {
          this.$message.error(this.$t("lang.alarmList.msg3"));
        });
      // }else{
      //   this.$message.warning('无变量需要重新采集！')
      // }
    },
    // 保存模板信息
    submitForm(submitType) {
      this.$refs["collectForm"].validate((valid) => {
        if (valid) {
          if (this.type === "edit" || this.collectForm.id) {
            // 编辑
            if (!isEqual(this.collectForm, this.copyData)) {
              // 有对内容进行修改时，才发起修改请求
              editTemplate(this.collectForm).then((res) => {
                if (res.data.code === 0) {
                  this.$message.success(this.$t("lang.rightAlarm.msg1"));
                  this.issave = true;
                  this.$emit("updateList");
                } else {
                  this.$message.error(this.$t("lang.collect.Savefailed"));
                }
              });
            }
          } else {
            // 添加
            console.log(this.collectForm);
            addTemplate(this.collectForm)
              .then((res) => {
                if (res.data.code === 0) {
                  this.$message.success(this.$t("lang.rightAlarm.msg1"));
                  this.issave = true;
                  this.$set(this.collectForm, "id", res.data.data);
                  this.templateId = this.collectForm.id;
                  this.$emit("updateList");
                } else {
                  this.$message.error(this.$t("lang.collect.Savefailed"));
                }
              })
              .catch(() => {});
          }
        } else {
          this.$message.warning(this.$t("lang.collect.msg10"));
          return false;
        }
      });
    },
    typeChange(e) {
      this.collectForm.type = e;
      this.$nextTick();
    },
  },
  destroyed() {
    this.issave = false;
  },
};
</script>
<style scoped>
.form-input {
  width: 4rem;
}
.group-tree {
  width: 200px;
}
</style>
